// extracted by mini-css-extract-plugin
export default {"container":"styles_container__t9CRE","logo":"styles_logo__Y7VlV"};